module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOBAMAAADgeEClAAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMAQ/pHevV2Sz4K58wkIhOAAwfAAAAAOklEQVQI12Ng4Nj0jYGB65MaA0P/FxsGBvvPDAyP/b/YMgjpf1KEEJz13ycwMMh/ZMAghBSBhGggAwDL0RG3JiIAKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-header-facebook.png
// module id = 290
// module chunks = 114276838955818 159515537771391